export default __webpack_public_path__ + "static/media/logo_GRCschema_h_color_overLight.48deecc2.png";